<template>
  <div>

    <!-- <Loading v-if="stage=='LOADING'"/>
    <Intro v-if="stage=='LOADED'"/>
    <Scroller v-if="stage=='ENTERED'"/>
    <Timeline v-if="stage=='ENTERED'"/>
    <Ending v-if="stage=='ENTERED'"/> -->

  </div>
</template>

<script>
// @ is an alias to /src
// import Loading from '@/components/Loading/index.vue'
// import Intro from '@/components/Intro/index.vue'
// import Timeline from '@/components/Timeline/index.vue'
// import Ending from '@/components/Ending/index.vue'
// import Scroller from '@/components/Scroller/index.vue'
export default {
  name: 'Home',

  components: {
    // Loading,
    // Intro,
    // Timeline,
    // Scroller,
    // Ending
  },

  data () {
    return {
      text: '',
      rot: 0
    }
  },

  mounted () {
    // document.getElementById('scroll').addEventListener("scroll", runOnScroll, {passive: true});
    // function runOnScroll(evt) {
    //   // console.log();
    //   this.rot=document.getElementById('scroll').scrollTop
    // }
  },

  computed: {
    stage () {
      return this.$store.state.stage
    }
  }
}
</script>

<style lang="scss" scoped>
.view {

}
</style>
